import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-executive-dashboard',
  templateUrl: './executive-dashboard.component.html',
  styleUrls: ['./executive-dashboard.component.sass']
})
export class ExecutiveDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
